import classnames from 'classnames';

import type { SearchedVehicle } from './types';
import VehicleIdentifier from './VehicleIdentifier';

import './styles/Vehicle.scss';

const Vehicle = ({ name, vin, licensePlate, connectivityStatus, severity }: SearchedVehicle) => (
    <div className='Vehicle'>
        <div
            data-testid='vehicle-status'
            className={classnames('Vehicle__severity', {
                'Vehicle__severity--fatal': severity === 'FATAL',
                'Vehicle__severity--error': severity === 'ERROR',
                'Vehicle__severity--warning': severity === 'WARNING',
                'Vehicle__severity--offline': severity === 'UNKNOWN' && connectivityStatus?.state !== 'ONLINE',
            })}
        />
        <VehicleIdentifier
            name={name}
            licensePlate={licensePlate}
            vin={vin}
            connectivityState={connectivityStatus?.state}
        />
    </div>
);

export default Vehicle;
